import { useIdentity } from '@zenbusiness/application-commons-identity';
import { useIntercom } from '@zenbusiness/application-commons-intercom';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

const IntercomButton = ({
  children,
  ...props
}) => {
  const {
    name, email, createdAt, userUuid
  } = useIdentity();
  const { update: updateIntercom, toggle: toggleIntercom } = useIntercom();
  const handleOpenIntercom = () => {
    updateIntercom({
      email,
      name,
      creationDate: createdAt,
      user_id: userUuid
    });
    toggleIntercom(true);
  };

  return (
    <Button
      onClick={handleOpenIntercom}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </Button>
  );
};

IntercomButton.propTypes = {
  children: PropTypes.node.isRequired
};

export default IntercomButton;
